import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import bg1 from "../assets/img/bg1.jpg";
import { useAuth } from "../Context/AuthContext";

export default function NewPassword() {
   const [email, setEmail] = useState("");
   const [submitted, setSubmitted] = useState(false);
   const { triggerForgotPasswordChallenge, errorMessage, setErrorMessage } = useAuth();
   const headerRef = useRef(null);

   useEffect(() => {
      if (headerRef.current) {
         headerRef.current.classList.remove("card-header");
      }
   }, []); // Runs once after the initial render

   const handleForgotPasswordSubmit = async (e) => {
      e.preventDefault();
      if (email) {
         await triggerForgotPasswordChallenge(email);
         setSubmitted(true);
      } else {
         setErrorMessage("Please enter your email address first.");
      }
   };

   return (
      <div className="page-sign d-block py-0">
         <Row className="g-0">
            <Col
               md="7"
               lg="5"
               xl="4"
               className="col-wrapper">
               <Card className="card-sign">
                  <Card.Header
                     ref={headerRef}
                     className="card-header-signin">
                     <Link
                        to="/"
                        className="header-logo mb-5">
                        Rekonsil
                     </Link>
                     <Card.Title>Forgot Password</Card.Title>
                     <Card.Text> {submitted ? `A password reset email has been sent to ${email}.` : "Enter your email to reset your password."}</Card.Text>
                  </Card.Header>
                  <Card.Body>
                     {!submitted && (
                        <Form onSubmit={handleForgotPasswordSubmit}>
                           <div className="mb-4">
                              <Form.Label>Email address</Form.Label>
                              <Form.Control
                                 type="email"
                                 placeholder="Enter your email address"
                                 value={email}
                                 onChange={(event) => setEmail(event.target.value)}
                              />
                           </div>
                           <Button
                              type="submit"
                              className="btn-sign">
                              Forgot Password
                           </Button>
                        </Form>
                     )}
                     {errorMessage && (
                        <p
                           className="pt-3"
                           style={{ color: "red" }}>
                           {errorMessage}
                        </p>
                     )}
                  </Card.Body>
                  <Card.Footer></Card.Footer>
               </Card>
            </Col>
            <Col className="d-none d-lg-block">
               <img
                  src={bg1}
                  className="auth-img"
                  alt=""
               />
            </Col>
         </Row>
      </div>
   );
}
